import Swal from "sweetalert2";
import { StyledButtonShowNft } from './styles';
import { blockchainService } from "../../../../services/blockchainService";

const labelNft = {
  ContratoAddress: "Endereço do Contrato",
  ContratoClienteAddress: "Endereço do Contrato (Cliente)",
  SignerGeral: "Assinante Geral",
  data_hora: "Data e Hora",
  description: "Documento",
  price: "Preço",
  royalty: "Royalty",
  title: "Título",
  is_nft_burned: "NFT Queimada?",
};

export const ShowNftInfoButton = ({ docId, mergeId }) => {
  const token = sessionStorage.getItem('Authorization');
  const headers = { Authorization: `Bearer ${token}` };

  const handleShowNft = async () => {
    try {

      const params = {};
      if (mergeId) params.merge_id = mergeId;
      else if (docId) params.doc_id = docId;
      else {
        console.warn("⚠️ Nenhum ID informado!");
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "É necessário informar docId ou mergeId.",
        });
        return;
      }

      // 🔁 Chamada centralizada via blockchainService
      const data = await blockchainService.getNftsByDocument(params, headers);

    

      const nfts = data.nfts || [];
  

      if (nfts.length === 0) {
        console.warn("⚠️ Nenhuma NFT retornada pela API!");
        Swal.fire({
          icon: "info",
          title: "Sem NFTs",
          text: "Não há NFTs associadas a este documento.",
        });
        return;
      }

      const htmlContent = nfts.map((nft) => {
        return Object.entries(nft)
          .filter(([key]) => labelNft.hasOwnProperty(key))
          .map(([key, value]) => {
            let displayValue = String(value);
            if (key === "is_nft_burned") displayValue = value ? "Sim" : "Não";
            return `<p><strong>${labelNft[key]}:</strong> ${displayValue}</p>`;
          })
          .join("");
      }).join("<hr/>");

  

      Swal.fire({
        title: "Informações da(s) NFT(s)",
        html: htmlContent,
        confirmButtonText: "Fechar",
        width: 600,
      });

    } catch (error) {
      console.error("❌ [ERRO] Falha ao buscar NFT:", error);

      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível carregar os dados da NFT.",
      });
    }
  };

  return (
    <StyledButtonShowNft style={{ float: 'left', marginLeft: '5px' }} onClick={handleShowNft}>
      Ver NFT
    </StyledButtonShowNft>
  );
};
